"use strict";
/**
 * The primary market picker's filter row: type chips and a text box, above
 * the Primary Market list. Renders only; the state and what a change does
 * are the caller's (`services/market-selection-service.ts`).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPrimaryMarketFilter = renderPrimaryMarketFilter;
const market_categories_1 = require("../markets/market-categories");
const CONTAINER_ID = "primary-market-filter";
const CHIP = "am-category-chip";
const CHIP_ACTIVE = "am-category-chip--active";
// The text box outlives a render, so its listener reads the latest handlers.
let currentHandlers = null;
/**
 * Draw the row for this event. The text box is built once and kept, so
 * re-rendering the chips never steals focus from it mid-typing.
 */
function renderPrimaryMarketFilter(markets, filter, handlers) {
    currentHandlers = handlers;
    const container = document.getElementById(CONTAINER_ID);
    if (!container)
        return;
    container.classList.toggle("hidden", markets.length < 2);
    let chips = container.querySelector(".primary-market-chips");
    if (!chips) {
        chips = document.createElement("div");
        chips.className = "am-market-category-row primary-market-chips";
        container.appendChild(chips);
    }
    let input = container.querySelector("input");
    if (!input) {
        input = document.createElement("input");
        input.type = "text";
        input.className = "parallel-markets-input primary-market-filter-input";
        input.placeholder = "Filter markets...";
        input.addEventListener("input", () => currentHandlers?.onText(input.value));
        container.appendChild(input);
    }
    if (input.value !== filter.text)
        input.value = filter.text;
    // Fewer than two types (a Kalshi event, usually) — nothing to choose between.
    const categories = (0, market_categories_1.deriveMarketCategories)(markets);
    chips.replaceChildren();
    chips.classList.toggle("hidden", categories.length < 2);
    if (categories.length < 2)
        return;
    const chip = (label, category) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = CHIP;
        button.classList.toggle(CHIP_ACTIVE, filter.category === category);
        button.textContent = label;
        button.addEventListener("click", () => handlers.onCategory(category));
        return button;
    };
    chips.appendChild(chip(`All (${markets.length})`, null));
    for (const c of categories)
        chips.appendChild(chip(`${c.label} (${c.count})`, c.key));
}
